export default __webpack_public_path__ + "static/media/jos-terminal.5a5b3316.png";